import moment from 'moment'
import React from 'react'
import { Field } from 'view/components/inputs'
import { Selectbox, SelectboxProps } from 'view/components/options'

type StartTimeSelectboxProps = Omit<SelectboxProps<string, string>, 'optionKeys'>

const StartTimeSelectbox: React.FC<StartTimeSelectboxProps> = props => {
  const StartTimes: string[] = []
  for (let hour = 0; hour < 24; hour++) {
    StartTimes.push(moment({ hour }).format('HH:mm'))
    StartTimes.push(moment({ hour, minute: 30 }).format('HH:mm'))
  }
  return <Selectbox optionKeys={StartTimes} {...props} />
}

export const StartTimeSelectboxField = Field(StartTimeSelectbox)
